module.exports = __webpack_public_path__ + "static/media/desseret1.c68d17b0.jpg";